import { ButtonHook } from 'common/Prose/Toolbar/Types'
import { computed } from 'mobx'
import { schema } from 'prose-core'
import { EditorView } from 'prosemirror-view'
import { useContext } from 'react'
import { AlmanacEditorStateContext } from 'stores/EditorState'
import { timedOutToggleMark } from '../utils/util'

export function useInlineCodeToggle(view: EditorView): ButtonHook {
  const almanacState = useContext(AlmanacEditorStateContext)
  const hasCode = computed(() => almanacState?.activeMarks.has(schema.marks.code)).get()
  const hasCodeBlock = computed(() => almanacState?.activeNodes.has(schema.nodes.code_block)).get()

  return {
    active: !!hasCode,
    handleClick: timedOutToggleMark(schema.marks.code, view),
    disabled: hasCodeBlock,
  }
}
